export default __webpack_public_path__ + "static/media/moviedb.70bcc27b.png";